import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal } from "shards-react";



import { Switch, Route, useHistory, useRouteMatch, useLocation, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { userActions, resourceAction, templateActions, } from '../../actions';

import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import { useFormik } from 'formik';
import { _getCategories } from './categoriesSize';

const NewTemplate = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const user = useSelector(state => state.authentication.user);
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const loading = useSelector(state => state.template.status);
  const createError = useSelector(state => state.template.error);
  const templateId = useSelector(state => state.template.templateId);
  const group = useSelector(state => state.authentication.user.group);
  const [initialValues, setInitialValues] = useState({
    name: '',
    price: '0',
    width: '',
    height: '',
    description: '',
    tags: '',
    tagsFa: ''
  })
  const [sendUpdate, setSendUpdate] = useState(0)
  const [size, setSize] = useState();
  const [createComplete, setCreateComplete] = useState();

  const categoriesSize = _getCategories();

  useEffect(() => {
    if (createComplete === 1) {
      if (loading === 'success') setCreateComplete(2)
      if (loading === 'failure') setCreateComplete(-1)
    }
  }, [loading])
  // useEffect(() => {
  //   console.log('createComplete', createComplete);
  // }, [createComplete])

  const handleSizeDDChange = (e) => {
    const wh = e.currentTarget.value.split("x");
    formik.setFieldValue('width', wh[0]);
    formik.setFieldValue('height', wh[1]);
    setSize(e.currentTarget.value)
  }

  const handleSizeChange = (e) => {
    formik.handleChange(e);
    const width = document.getElementById('width').value;
    const height = document.getElementById('height').value;
    const newSize = _.find(categoriesSize, { size: `${width}x${height}` })
    if (newSize) {
      setSize(`${width}x${height}x${newSize.id}`)
    } else {
      setSize('custom')
    }
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: values => {
      setCreateComplete(1)
      let tags, tagsFa;
      if (typeof values.tags === 'string') {
        tags = values.tags.split(",");
      } else {
        tags = values.tags;
      }
      if (typeof values.tagsFa === 'string') {
        const newTagsFa = values.tagsFa.replace(/،/g, ",")
        tagsFa = newTagsFa.split(",");
      } else {
        tagsFa = values.tagsFa;
      }
      const category = _.find(categoriesSize, { id: parseInt(size.split('x')[2]) });
      dispatch(
        templateActions.create({
          name: values.name,
          price: values.price,
          // invisible: group === 'vibino' ? false : true,
          invisible: true,
          size: { width: values.width, height: values.height },
          description: values.description,
          tagsFa: tagsFa,
          tags: tags,
          group: group,
          categories: category ? [category.name] : [],
        }),
      );
    },

  });




  return (

    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      {sendUpdate === 2 && (<span className="alertSuccess">Update Successful</span>)}
      {sendUpdate === -1 && (<span className="alertDanger">Update Failed!</span>)}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Create New Template" subtitle="Templates" className="text-sm-left" />
      </Row>
      {createComplete === -1 && <div role="alert" className="alertDanger">{_.get(createError, 'error', 'Could not create template. Please try again.')}</div>}
      <form className={sendUpdate !== 0 && loading === 'loading' ? 'blur' : ""} onSubmit={formik.handleSubmit}>
        <Row>

          <Col>
            <Row>
              <Col lg="4">
                <span>Name:</span>
                <input id="templateName" name="name" required value={formik.values.name} onChange={formik.handleChange} />
              </Col>
              <Col>
                <span>Description:</span>
                <input id="description" name="description" value={formik.values.description} onChange={formik.handleChange} />
              </Col>
            </Row>
            <Row>
              <Col>
                <span>Value:</span>
                <select id="price" name="price" value={formik.values.price} onChange={formik.handleChange} >
                  <option value="0">Free</option>
                  <option value="1">Premium</option>
                </select>
              </Col>
              <Col>
                <span>Size:</span>
                <select id="size" name="size" value={size} onChange={handleSizeDDChange} >
                  <option value="" hidden>---</option>
                  {categoriesSize.map(option =>
                    <option key={option.id} value={`${option.size}x${option.id}`}>{`${option.name} (${option.size})`}</option>
                  )}
                  <option value="custom">Custom</option>
                </select>
              </Col>
              <Col>
                <span>Width (px):</span>
                <input id="width" name="width" required value={formik.values.width} onChange={handleSizeChange} />
              </Col>
              <Col>
                <span>Height (px):</span>
                <input id="height" name="height" required value={formik.values.height} onChange={handleSizeChange} />
              </Col>
            </Row>
            <Row>
              <Col>
                <span>Tags (En):</span>
                <textarea id="tags" name="tags" value={formik.values.tags} onChange={formik.handleChange} />
              </Col>
              <Col>
                <span>Tags (Fa):</span>
                <textarea id="tagsFa" name="tagsFa" value={formik.values.tagsFa} onChange={formik.handleChange} />
              </Col>
            </Row>
            <Row noGutters className="buttonHolder">
              <Col>
                <Button type="submit" theme="success"><i className="material-icons"></i> Create</Button>
                <Button className="" theme="danger" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Cancel</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
      {createComplete === 2 && (
        <div className="vModal">
          <div className="vModalContent">
            <div className="vModalHeader">Create complete successfully</div>
            <div className="vModalBody">New template created successfully, Please choose action to continue.</div>
            <div className="vModalFooter">
              <Button theme="success" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Start Design</Button>
              <Button className="" theme="primary" onClick={() => history.push(`/template/${templateId}/edit`)}><i className="material-icons"></i> Upload Resources</Button>
              <Button className="" theme="primary" onClick={() => history.go(0)}><i className="material-icons"></i> Close & New</Button>
              <Button className="" theme="danger" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Close</Button>
            </div>
          </div>
        </div>
      )}
    </Container>

  );
}

export default NewTemplate;
